export enum ProductType {
  WILL = "will-optimized",
  HCP = "hcp-multi-product",
  POA = "product-poa-multi",
}
